import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { createAgreementAction, getTypesAndTargetsAction } from '@store/actions/agreements';
import { getCreateStatus, getErrors, getTypes, getTargets, getTypesStatus } from '@store/reducers/agreements/selectors';
import Main from './Main';

const mapStateToProps = state => ({
  createStatus: getCreateStatus(state),
  errors: getErrors(state),
  types: getTypes(state),
  targets: getTargets(state),
  typeStatus: getTypesStatus(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      createAgreementAction,
      getTypesAndTargetsAction,
    },
    dispatch,
  ),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Main);
